import { Navigate } from "react-router-dom";
import { usePhysicianAuthStore } from "@/stores/physicianAuthStore";

export function PhysicianGuestOnly({ children }: { children: React.ReactNode }) {
  const isAuthenticated = usePhysicianAuthStore((s) => s.isAuthenticated);
  const isLoading = usePhysicianAuthStore((s) => s.isLoading);

  if (isLoading) return null; // wait for session restore before deciding
  if (isAuthenticated) return <Navigate to="/physician" replace />;
  return <>{children}</>;
}
